import React from 'react';
import styled from 'styled-components';

import { Futura } from '~/styles';
import { media } from '~/utils';

export default function ({ recruitments, large = false, onClick }) {
  const categories = {};

  for (const r of recruitments) {
    if (!categories[r.category]) categories[r.category] = 0;

    categories[r.category] += 1;
  }

  return (
    <Wrapper large={large}>
      <Title>募集</Title>
      <Categories large={large}>
        {Object.keys(categories).map((k, index) => (
          <Category large={large} key={index}>
            {k}
            <CategoryCount>{categories[k]}</CategoryCount>
          </Category>
        ))}
      </Categories>
      {!large && <SeeMore onClick={onClick}>SEE MORE</SeeMore>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: ${(props) => (props.large ? 'auto' : '235px')};
  background: #fff;
  border-radius: 10px;
  display: flex;
  background: #707070;
  flex-direction: column;
  position: relative;
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #fff;
`;

const Categories = styled.div`
  margin-top: 5px;
  margin-left: 35px;
  margin-right: 35px;

  ${(props) =>
    props.large &&
    `
    margin-bottom: 40px;
  `}
`;

const Category = styled.div`
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  text-decoration: underline;

  ${media.mid`
    width: 200px;
  `}

  ${(props) =>
    props.large &&
    `
    width: 300px;
  `}
`;

const CategoryCount = styled.div`
  float: right;
  text-decoration: none;
`;

const SeeMore = styled(Futura)`
  position: absolute;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  z-index: 1;
  left: 35px;
  bottom: 10px;
  color: #fff;
`;
